import React, { useState } from "react";
import { Link } from "react-router-dom";
import Sidebar from "../../partials/aside/Sidebar";
import TitleBar from "../../partials/content/TitleBar";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import StateSiteUserPublisher from "./StateSiteUserPublisher";
import sites from "./Sites";
import ButtonDisable from "../../partials/other/ButtonDisable";

export default function InfoSite() {
  const params = useParams();
  const sitePublisherID = params.sitePublisherID;
  const [copied, setCopied] = useState(false);
  let site = sites.filter((site) => site.ID == sitePublisherID);
  site = site[0];
  const htmlTag = `<script class="hilite-script" data-hilite="${site.script_ID}" src="https://unpkg.com/hilite-script-site-publisher@latest/dist/script.min.js"></script>`;

  const generateUserSitePublisherInfo = () => {
    let classNameBadgeType = "";
    switch (site.status) {
      case StateSiteUserPublisher.statusSiteUserPublisher.PENDING:
        classNameBadgeType = "warning";
        break;
      case StateSiteUserPublisher.statusSiteUserPublisher.CONFIRM:
        classNameBadgeType = "success";
        break;
      case StateSiteUserPublisher.statusSiteUserPublisher.REJECT:
        classNameBadgeType = "danger";
        break;
    }
    return (
      <>
        <div className="text-left pb-2">
          <Link className="btn btn-primary" to="/site/all">
            <span>بازگشت</span>
            <span className="pr-2">
              <i className="fas fa-arrow-left"></i>
            </span>
          </Link>
        </div>
        <div className="table-responsive">
          <table className="table table-hilite m-0">
            <thead>
              <tr>
                <td
                  colSpan={2}
                  className="text-center"
                  style={{ borderRadius: "25px 25px 0 0" }}
                >
                  <b>اطلاعات سایت نمایش دهنده شما</b>
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>شماره سایت نمایش دهنده</td>
                <td>{site.ID}</td>
              </tr>
              <tr>
                <td>آدرس سایت</td>
                <td>
                  <a target="_blank" href={site.url}>
                    {site.url}
                  </a>
                </td>
              </tr>
              <tr>
                <td>حالت</td>
                <td>
                  <span
                    className={`badge  badge-${
                      site.active ? "success" : "danger"
                    }`}
                  >
                    {site.active ? "فعال" : "غیرفعال"}
                  </span>
                </td>
              </tr>
              <tr>
                <td>وضعیت</td>
                <td>
                  <span className={`badge badge-${classNameBadgeType}`}>
                    {site.status}
                  </span>
                </td>
              </tr>
              {StateSiteUserPublisher.statusSiteUserPublisher.REJECT ===
                site.status && (
                <tr>
                  <td>پیغام</td>
                  <td>{site?.message}</td>
                </tr>
              )}

              {StateSiteUserPublisher.statusSiteUserPublisher.CONFIRM ===
                site.status && (
                <tr>
                  <td>اسکریپت</td>
                  <td dir="ltr" className="text-left">
                    <span className="pr-2">{htmlTag}</span>
                    <span>
                      <button
                        className="btn btn-info"
                        onClick={(e) => {
                          e.preventDefault();
                          navigator.clipboard.writeText(htmlTag);
                          setCopied(true);
                        }}
                      >
                        <i className="fas fa-copy pr-2"></i>
                        {copied ? "کپی شد" : " کپی  "}{" "}
                      </button>
                    </span>
                  </td>
                </tr>
              )}

              <tr>
                <td>تاریخ درج</td>
                <td>{site.created_at}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="pt-2">
          {StateSiteUserPublisher.statusSiteUserPublisher.REJECT ===
            site.status && (
            <ButtonDisable
              buttonTagHtml={
                <button className="btn btn-success opacity-50">
                  ارسال درخواست بررسی دوباره
                </button>
              }
            ></ButtonDisable>
          )}
        </div>
      </>
    );
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar title="اطلاعات سایت ها نمایش دهنده شما" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">{generateUserSitePublisherInfo()}</div>
          </div>
        </section>
      </div>
    </>
  );
}
